export default {
    state: {
        tabs: [],
        active_tab: 0,
    },
    mutations: {
        setHeaders(state, tabs) {
            state.tabs = tabs;
        },
        setActiveTab(state, tabIndex) {
            state.active_tab = tabIndex;
        },
        clearTabs(state) {
            state.tabs.length = 0;
        },
    },
    actions: {
        setTabs({ commit }, tabs) {
            commit('setHeaders', tabs);
        },
        changeActiveTab({ commit }, tabIndex) {
            commit('setActiveTab', tabIndex);
        },
        clearTabs({ commit }) {
            commit('clearTabs');
        },
    },
    getters: {
        getTabs: state => state.tabs,
        activeTab: state => state.active_tab,
    },
};
